import { toast } from "react-toastify";
import { useLogoutUserMutation } from "../services/auth/authApiSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { billsApi } from "../services/bills/BillsApiSlice";
import { landingPageApi, useGetEmployeeLogoutMutation } from "../services/invoices/InvoiceApiSlice";
import { authApi } from "../services/auth/authApiSlice";
import { vendorApi } from "../services/vendor/VendorApi";
import { SSO_BASE_URL } from "../utils/constants";

const useLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [handleLogoutClick] = useLogoutUserMutation();
  const [getSessionLogout] = useGetEmployeeLogoutMutation();

  const handleSSOLogin = () => {
    const baseURL = window.location.origin;
    window.location.href = `${SSO_BASE_URL}/auth?redirect=${baseURL}/sso`;
  };

  const handleLogout = async () => {
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("userRole");
    if (role === "vendor") {
      try {
        await getSessionLogout({});
        await handleLogoutClick({ Token: token }).unwrap();

        dispatch(billsApi.util.resetApiState());
        dispatch(landingPageApi.util.resetApiState());
        dispatch(authApi.util.resetApiState());
        dispatch(vendorApi.util.resetApiState());

        navigate("/login", { replace: true });
        localStorage.clear();
      } catch (err) {
        console.error("ERR: ", err);
        toast.error("Logout unsuccessful");
      }
    } else {

      setTimeout(() => {
        dispatch(billsApi.util.resetApiState());
        dispatch(landingPageApi.util.resetApiState());
        dispatch(authApi.util.resetApiState());
        dispatch(vendorApi.util.resetApiState());
      }, 5000)

      localStorage.clear();

      // window.location.href = `${SSO_BASE_URL}/logout`;
      window.history.pushState(null, window.location.pathname);
      // navigate(`${SSO_BASE_URL}/logout`, { replace: true });
      window.location.replace(`${SSO_BASE_URL}/logout`);
    }
  };
  return {
    handleLogout,
    handleSSOLogin,
  };
};

export default useLogin;
